import 'babel-polyfill';

import 'bootstrap';
import 'highcharts';

import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App/App';
import client from 'App/util/graphql/client';
import store from 'App/util/redux/store';
import createHistory from 'history/createBrowserHistory';
import {authRefreshSession} from 'App/util/redux/auth/actions';
import {selectors as authSel} from 'App/util/redux/auth/reducer';
import {Provider} from 'react-redux';
import {ApolloProvider} from 'react-apollo';

// TextEncoder and TextDecoder polyfill for IE
import TextEncodingPolyfill from 'text-encoding';

if (typeof TextEncoder !== 'function') {
  window.TextEncoder = TextEncodingPolyfill.TextEncoder;
  window.TextDecoder = TextEncodingPolyfill.TextDecoder;
}
// import requires in order to activate the export function:
// import 'highcharts/css/highcharts.css';
import HighchartsExport from 'highcharts/js/modules/exporting';
import HighchartsOfflineExport from 'highcharts/js/modules/offline-exporting';
import HighchartsDrilldown from 'highcharts/js/modules/drilldown';
import HighchartsBoost from 'highcharts/js/modules/boost';
import HighchartsAccess from 'highcharts/js/modules/accessibility';
import HighchartsMap from 'highcharts/js/modules/map';
// import HighchartsExportData from 'highcharts/js/modules/export-data';

import ReactHighcharts from 'react-highcharts';

HighchartsDrilldown(ReactHighcharts.Highcharts);
HighchartsExport(ReactHighcharts.Highcharts);
HighchartsOfflineExport(ReactHighcharts.Highcharts);
HighchartsBoost(ReactHighcharts.Highcharts);
HighchartsAccess(ReactHighcharts.Highcharts);
HighchartsMap(ReactHighcharts.Highcharts);
// HighchartsExportData(ReactHighcharts.Highcharts);

import ReactHighmaps from 'react-highcharts/ReactHighmaps';

HighchartsDrilldown(ReactHighmaps.Highcharts);
HighchartsExport(ReactHighmaps.Highcharts);
HighchartsOfflineExport(ReactHighmaps.Highcharts);

const credits = {
  href: 'https://esid.org',
  text: `\u00A9 ESID ${(new Date()).getFullYear()}`,
  position: {
    align: 'left',
    x: 15,
  }
};

ReactHighcharts.Highcharts.setOptions({credits});
ReactHighmaps.Highcharts.setOptions(
  {
    credits,
    mapNavigation: {
      enableMouseWheelZoom: false
    },
    legend: {
      itemStyle: {
        textOverflow: 'none',
      }
    },
  }
);


// refresh session cookie on route change inside the toolkit
// this implicitly refreshes the timer (this is done on each graphql request)
const history = createHistory();

history.listen((location, action) => {
  // const path = `${location.pathname}${location.search}${location.hash}`;
  const state = applicationStore.getState();
  if (authSel.user(state) !== null) {
    applicationStore.dispatch(authRefreshSession());
  }
});

// workaround: export the store in order to be able to
// get it from everywhere of the application
export const applicationStore = store;
export const applicationClient = client;

ReactDOM.render((
  <Provider store={applicationStore}>
    <ApolloProvider client={applicationClient}>
      <App/>
    </ApolloProvider>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js